exports.en = {
  UNIFORM_INPUT_CHECKBOX_GDPR: {
    CHECK_REQUIRED: 'Check is required.'
  }
}
